import { MediaInfosSidenavController } from "./media-infos-sidenav.controller";

angular
    .module("thor.shared.media-infos-sidenav.component", [])
    .component("mediaInfosSidenav", {
        bindings: {
            item: "<",
            close: "&",
            closeSidenav: "&"
        },
        controller: MediaInfosSidenavController,
        template: require("../../../shared/media-gallery/media-infos-sidenav/media-infos-sidenav.html")
    });
